// 規約・方針ページの外枠。
//
// ■ なぜ会員レイアウトと分けるか
// 利用規約と個人情報保護方針は、**登録前・ログイン前に読めなければ意味がない**。
// 個人情報を預けるかどうかを判断するための文書だから。
// そのため会員レイアウト (RequireAuth + HearingGate の内側) には置けず、
// ログイン画面と同じ「認証なしで開ける枠」が要る。
//
// 見た目はログイン画面と揃えてある（ヘッダにブランド表記、本文は中央寄せ）。
// ブランド表記はトップへのリンクを兼ねる。ログイン済みなら会員ページへ、
// 未ログインならログイン画面へ戻れるので、どちらの状態でも行き止まりにならない。
import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { BrandLockup } from "./BrandLockup";
import { brand } from "../lib/brand";

export function LegalLayout({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen flex flex-col bg-tora-paper">
      <header className="bg-white border-b-2 border-tora-accent">
        <div className="mx-auto max-w-7xl px-4 py-3">
          <Link
            to="/"
            className="inline-flex [@media(pointer:coarse)]:py-2"
            aria-label={`${brand.name} トップ`}
          >
            <BrandLockup />
          </Link>
        </div>
      </header>

      <main className="flex-1 px-4 pb-10">{children}</main>

      <footer className="border-t border-black/10 py-6 text-center text-sm text-tora-ink/50">
        <div className="flex items-center justify-center gap-4">
          <span>© {brand.name}</span>
          <a
            href={`mailto:${brand.supportEmail}`}
            className="hover:text-tora hover:underline"
          >
            お問い合わせ
          </a>
        </div>
      </footer>
    </div>
  );
}
